module.exports = [
  {
    text: "HRMS Onboarding",
    // logo: `${process.env.PUBLIC_URL}/assets/images/logos/hrms1.svg`,
    linkUrl: "https://hrmsonboarding.indusgroup.org/",
  },
  {
    text: "Hubble Orion AMS",
    // logo: `${process.env.PUBLIC_URL}/assets/images/logos/hrms1.svg`, 
    linkUrl: "https://ams.indusgroup.org/",
  },
  {
    logo: `${process.env.PUBLIC_URL}/assets/images/logos/people_strong.svg`,
    linkUrl: "https://auth.peoplestrong.com/",
  },
];